import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive(
  {
    selector: '[appStringFormat]',
  },
)
export class StringFormatDirective {

  @Input() option: string;
  @Input() maxLength: number;

  constructor(private el: ElementRef, private render: Renderer2, private control: NgControl) {
  }

  @HostListener('input') oninput() {
    const abstracControl = this.control.control;
    let value: string = this.el.nativeElement.value;
    switch (this.option) {
      case undefined:
        // @ts-ignore
        value = value.match(/^[a-zA-Z ]*/).join();
        break;
      case 'number':
        value = value.replace(/[^0-9]*/g, '');
        break;
      case 'alfa':
        // @ts-ignore
        value = value.match(/^[a-zA-Z0-9 ]*/).join();
        break;
    }
    if (this.maxLength) {
      value = value.substring(0, this.maxLength);
    }

    // @ts-ignore
    abstracControl.setValue(value);
    this.render.setProperty(this.el.nativeElement, 'value', value);
  }

  @HostListener('change') onchange() {
    const abstracControl = this.control.control;
    let value: string = this.el.nativeElement.value;
    value = value.trim();
    // @ts-ignore
    abstracControl.setValue(value);
  }
}
